import React from "react";
import Home from "./Home";
import Axios from 'axios';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  async componentDidCatch(error, errorInfo) {
    if(error) {
        const link_api = (window.location.host === 'openaccount.nhsec.co.id') ? process.env.REACT_APP_BASE_URL_PROD : process.env.REACT_APP_BASE_URL_DEV;
        let userAgent = navigator.userAgent;
        await Axios.post(link_api + '/api/log-service', {ipAddress: '-', userAgent: userAgent, errorTitle: error.toString(), errorBody: errorInfo.componentStack });
    }
    
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <div>
          <h2>Something went wrong.</h2>
          <details style={{ whiteSpace: "pre-wrap" }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}

// In-app 브라우저 감지 — 카메라/iframe 호환성 사고 예방
function InAppBrowserGuard({ children }) {
  const [dismissed, setDismissed] = React.useState(false);

  if (dismissed) return children;

  const ua = (typeof navigator !== 'undefined' && navigator.userAgent) ? navigator.userAgent : '';
  const isInApp = /KAKAOTALK|Line\/|Instagram|FBAN|FBAV|FB_IAB|Twitter|NAVER|whale|MicroMessenger|MiuiBrowser|wv\)/i.test(ua);

  if (!isInApp) return children;

  const currentUrl = (typeof window !== 'undefined') ? window.location.href : '';
  const isiOS = /iPad|iPhone|iPod/.test(ua);

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      background: '#f7f7f7', zIndex: 99999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '20px', boxSizing: 'border-box', fontFamily: 'sans-serif'
    }}>
      <div style={{
        background: '#fff', borderRadius: 8, padding: '24px',
        maxWidth: 420, boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        textAlign: 'center'
      }}>
        <h3 style={{ marginTop: 0, color: '#0d47a1' }}>Buka di browser luar / Open in external browser</h3>
        <p style={{ fontSize: 14, color: '#333', lineHeight: 1.6 }}>
          Untuk pengalaman terbaik (kamera, Liveness Detection), silakan buka link ini di Safari atau Chrome.<br/><br/>
          <em>For the best experience (camera, Liveness Detection), please open this link in Safari or Chrome.</em>
        </p>
        <div style={{
          background: '#f0f0f0', padding: '8px 12px', borderRadius: 4,
          fontSize: 12, wordBreak: 'break-all', margin: '12px 0', color: '#555'
        }}>
          {currentUrl}
        </div>
        <p style={{ fontSize: 12, color: '#888', margin: '12px 0' }}>
          {isiOS
            ? '1) URL salin → 2) Safari 열기 → 3) 주소창에 붙여넣기'
            : '1) URL 복사 → 2) Chrome 열기 → 3) 주소창에 붙여넣기'}
        </p>
        <button
          onClick={() => {
            if (typeof navigator !== 'undefined' && navigator.clipboard) {
              navigator.clipboard.writeText(currentUrl).catch(() => {});
            }
            alert('URL telah disalin / URL copied');
          }}
          style={{
            background: '#0d47a1', color: '#fff', border: 'none',
            padding: '10px 20px', borderRadius: 4, fontSize: 14, cursor: 'pointer',
            marginRight: 8
          }}
        >
          Salin URL / Copy URL
        </button>
        <button
          onClick={() => setDismissed(true)}
          style={{
            background: '#fff', color: '#666', border: '1px solid #ccc',
            padding: '10px 20px', borderRadius: 4, fontSize: 14, cursor: 'pointer'
          }}
        >
          Lanjutkan / Continue anyway
        </button>
      </div>
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <InAppBrowserGuard>
        <Home />
      </InAppBrowserGuard>
    </ErrorBoundary>
  );
}

export default App;
